export type LinkType = {
  title: string;
  url: string;
};
export type CardType = {
  title: string;
  list: LinkType[];
};
export type DocumentType = {
  title: string;
  list: CardType[];
};


export enum DocsMessageAction {
  CONNECT='connect',
  ROUTER_CHANGE='routerChange',
  HREF_CHANGE='hrefChange',
  GET_SIZE='getSize'
}